import { render, staticRenderFns } from "./PublishedSection.vue?vue&type=template&id=8fe1fc9a&scoped=true&"
import script from "./PublishedSection.vue?vue&type=script&lang=js&"
export * from "./PublishedSection.vue?vue&type=script&lang=js&"
import style0 from "./PublishedSection.vue?vue&type=style&index=0&id=8fe1fc9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe1fc9a",
  null
  
)

export default component.exports